"use client";

import LoginSwitcher from "@/components/web/blocks/loginSwitcher";

export default function LoginPage() {
  return (
    <div className="-mt-20 flex min-h-screen w-full items-center justify-center bg-gradient-to-br from-sky-100 to-blue-200 p-4">
      <LoginSwitcher />
    </div>
  );
}
